import axios from "axios";

const useClientsViewModel = () => {
  const deleteFoldersClient = async (
    _id,
    data,
    setClients,
    setNotify,
    searchClients,
  ) => {
    try {
      const result = await axios.post(`/remote/folders/clear-all`, {
        _id: _id.toString(),
      });

      if (result.data.message === "folders-cleared") {
        await remoteDeleteClient(
          _id,
          data,
          setClients,
          setNotify,
          searchClients,
        );
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setNotify({
          type: "error",
          message: "Error.",
        });
      }
    }
  };

  const remoteDeleteClient = async (
    _id,
    data,
    setClients,
    setNotify,
    searchClients,
  ) => {
    await axios
      .post(`/remote/clients/delete`, {
        _id: _id.toString(),
      })
      .then((result) => {
        if (result.data.message === "deleted") {
          const newClients = (data || []).filter((v) => {
            const vid = v && v._id ? v._id.toString() : "";
            return vid !== _id.toString();
          });

          setClients({
            total: newClients.length,
            data: newClients,
          });

          setNotify({ type: "success", message: "client deleted" });

          if (typeof searchClients === "function") {
            searchClients();
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          if (err.response.data.message === "existing-folders") {
            setNotify({
              type: "error",
              message: "Client with folders.",
            });
          }
        }
      });
  };

  const deleteClient = async (
    _id,
    temp,
    setTemp,
    setClients,
    setNotify,
    searchClients,
    data,
  ) => {
    let hasFolders = false;
    try {
      const results = await axios.post(
        `/remote/clients/check-folders`,
        { _id: _id.toString() }
      );

      hasFolders = Boolean(
        results?.data?.exists ?? results?.data?.hasFolders ?? false,
      );
    } catch (err) {
      setNotify({ type: "error", message: "Error." });
      return;
    }

    if (hasFolders) {
      const temp2 = Object.assign({}, temp);
      temp2.confirm = {
        title: "Delete Client and All Folders?",
        cancel_text: "No, Keep Everything",
        confirm_text: "Yes, Delete All",
        callback_color: "error",
        text: "This client has active folders. Deleting this client will PERMANENTLY remove all associated folders and data.",
        callback: async () => {
          await deleteFoldersClient(
            _id,
            data,
            setClients,
            setNotify,
            searchClients,
          );
        },
      };
      setTemp(temp2);
      return;
    }

    await remoteDeleteClient(_id, data, setClients, setNotify, searchClients);
  };

  return {
    deleteClient,
  };
};

export default useClientsViewModel;
